import { FloatingAlertList } from 'foundations-components/transitional/components/FloatingAlertList';

// I18n Configuration
import { initAppTranslations } from 'I18n/init/setup/AppInit';
import { LocaleProvider } from './components/locales/LocaleProvider';
import { loadLocale, resolveInitialLocale } from './utils/setupI18n';

// Configure the router
import { Routes } from './components/Routes';

// Apollo
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const prepareApp = async () => {
  /*
   * Only the locale the page is about to render in is fetched here. The ALL
   * provider we used before eagerly loaded every locale chunk in `lang/` on
   * every page load, which is what generated the ChunkLoadError timeouts.
   * `LocaleProvider` loads any other locale on demand when the language select
   * changes.
   */
  const initialLocale = await resolveInitialLocale(window.location.search);
  await initAppTranslations([loadLocale(initialLocale)]);
  const dataFetchingClient = new DataFetchingClient();
  return {
    props: {
      dataFetchingClient
    }
  };
};
export function AppComponent({
  dataFetchingClient
}) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FloatingAlertList, {}), /*#__PURE__*/_jsx(DataFetchingClientProvider, {
      client: dataFetchingClient,
      children: /*#__PURE__*/_jsx(LocaleProvider, {
        children: /*#__PURE__*/_jsx(Routes, {})
      })
    })]
  });
}